import {SEARCHED_REF_NUMBER} from './actions';

export interface IAppState {
  searchedRefNumber: string;
}

export const INITIAL_STATE: IAppState = {searchedRefNumber: undefined};

export function rootReducer(state: IAppState, action): IAppState {
  switch (action.type) {
    case SEARCHED_REF_NUMBER:
      return {searchedRefNumber: action.value};
  }
  return state;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/store.ts